import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';
import { CRMService } from 'src/app/services/crm/crm.service';
import * as crmActions from '../../actions/crm/crm.actions';

@Injectable()
export class CRMEffects {
  store: any;

  constructor(private actions$: Actions, private crmService: CRMService) {}

  getCrmOffers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(crmActions.getCRMOffersApi),
      exhaustMap(() =>
        this.crmService.getCRMOffers().pipe(
          map((resp: HttpResponse<any>) => {
            let crmBody = {
              careForCustomer: resp.body?.careForCustomer,
              nextBestOffer: resp.body?.nextBestOffer,
              salesCampaign: resp.body?.salesCampaign,
              countMessages: resp.body?.countMessages
            };
            return crmActions.getCRMOffersSuccess({
              offers: crmBody ? crmBody : null
            });
          })
        )
      )
    );
  });

  // getCrmOffers$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(crmActions.getCRMOffersApi),
  //     switchMap(() =>
  //       this.crmService.getCRMOffers().pipe(
  //         map((resp: HttpResponse<any>) => this.handleCrmOffersResponse(resp)),
  //         catchError(error => of(crmActions.getCRMOffersFailure({ error })))
  //       )
  //     )
  //   )
  // );

  // private handleCrmOffersResponse(resp: HttpResponse<any>) {
  //   const crmBody = {
  //     careForCustomer: resp.body?.careForCustomer,
  //     nextBestOffer: resp.body?.nextBestOffer,
  //     salesCampaign: resp.body?.salesCampaign,
  //     countMessages: resp.body?.countMessages
  //   };
  //   return crmActions.getCRMOffersSuccess({ offers: crmBody || null });
  // }

  countCrmOffers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(crmActions.countCRMOffersApi),
      switchMap(() =>
        this.crmService.countOffers().pipe(
          map((resp: HttpResponse<{ data: number }>) => {
            return crmActions.countCRMOffersSuccess({
              count: resp.body ? resp.body.data : 0
            });
          }),
          catchError(error => of(crmActions.countCRMOffersFailure({ error })))
        )
      )
    );
  });
}
